import Schema from 'AppReact/schema';

export default {
  image: Schema('string', 'primitive-nullable', { defaultValue: null }),
  name: Schema('string', 'primitive', { defaultValue: '' }),
  role: Schema('string', 'primitive-nullable', { defaultValue: null }),
  assignments: Schema('integer', 'primitive', { defaultValue: 0 }),
  completion_time: Schema('integer', 'primitive', { defaultValue: 0 }),
  rating: Schema('integer', 'primitive', { defaultValue: 0 }),
  id: Schema('integer', 'primitive', { defaultValue: 0 }),
  assignedId: Schema('integer', 'primitive', { defaultValue: 0 }),
  displayButton: Schema('boolean', 'primitive', { defaultValue: false }),
}